<template>
  <FreeBottomSheet :name="name">
    <template #header>
      <div class="px-4 pb-2 pt-4 font-medium">
        {{ params.segments.dep }} → {{ params.segments.arr }}
      </div>
    </template>
    <template #default>
      <div class="space-y-2 px-4 pb-4 pt-2">
        <FareCard
          v-for="(choice, idx) in params.choices"
          :key="choice.id"
          :choice="choice"
          :fare-idx="idx + 1"
          :selected-id="params.selectedId"
          :is-domestic="params.isDomestic"
          @onFareSelect="onFareSelect({ groupKey: params.groupKey, choice })"
        />
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { FreeBottomSheet } from 'freedom-shared';

  import type { FareFamilyChoiceSpec } from '../model';
  import { useFareFamilyBottomSheet } from './use-fare-family-bottom-sheet';
  import FareCard from './FareCard.vue';

  const emit = defineEmits<{
    onFareSelect: [{ groupKey: string; choice: FareFamilyChoiceSpec }];
  }>();

  const { params, hide, name } = useFareFamilyBottomSheet();

  function onFareSelect({
    groupKey,
    choice,
  }: {
    groupKey: string;
    choice: FareFamilyChoiceSpec;
  }) {
    if (params.value.selectedId !== choice.id) {
      emit('onFareSelect', { groupKey, choice });
    }
    hide();
  }
</script>
